module.exports = __webpack_public_path__ + "static/media/passwordIcon.8035bcd0.svg";